<template>
  <NuxtLink v-bind="nuxtLinkProps" :to="preparedRoute">
    <slot />
  </NuxtLink>
</template>

<script setup lang="ts">
import { omit } from '@st/utils'
import type { RouteLocationRaw } from 'vue-router'
import type { NuxtLinkProps } from '#app'
import { addPrefixes } from '@st/i18n-base/utils'

interface Props extends NuxtLinkProps {
  locale?: string
  to: RouteLocationRaw
  platform?: 'mobile' | 'desktop'
}

const props = defineProps<Props>()

const nuxtLinkProps = computed(() =>
  omit(props, ['locale', 'to', 'noPrefetch']),
)

const { locale: globalLocale } = useNuxtApp().$i18n
const { platform: globalPlatform } = usePlatform()
const router = useRouter()
const currentRoute = useRoute()

/*
  TODO: перевести сторибук на английский язык и выпилить этот компьютед
  https://jira.sxl.team/browse/ST-10756
*/
const currentRouteParams = computed(() => parsePath(currentRoute.fullPath))

const preparedRoute = computed(() => {
  const {
    to,
    locale = currentRouteParams.value.locale ?? globalLocale.value,
    platform = currentRouteParams.value.platform ?? globalPlatform.value,
  } = props

  if (typeof to === 'string' && !to.startsWith('/')) {
    return props.to
  }

  const route = router.resolve(to)
  return addPrefixes(route.href, {
    locale,
    platform,
  })
})
</script>
